(function (angular) {

  angular.module("alk.translations", [
    "pascalprecht.translate",
    "tmh.dynamicLocale",
    "ngCookies"
  ]);

})(window.angular);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-translations/module.js